import React from 'react'
import { Field } from 'redux-form';
import { Item, InputPicker, painel } from 'scorpion-core';
import Tags from './components/Tags'

import { FiltroStringScorpion } from 'scorpion-core'


function componentRelEspelho(comp, dados) {
    return painel([
        [{ style: "cellTitulo", text: comp.label }], [{ style: "cellValor", text: dados[comp.field] }]
    ], { widths: ['*'] })

}


function component(item, propsG) {
    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} label={item.label} component={Tags} {...item.propsadd} customFormUid={propsG.customFormUid} item={item} />
    </Item>)
}

const modelo = {
    field: "tag",
    label: "Tags",
    typeComponente: "Tags",
    requerido: false,
}

const comp = {
    typeComponente: "Tags",
    configView: {
        nome: "Tags",
        modelo,
    },
    componentRelEspelho,
    component,
    renderFiltro: (props) => {
        const { col, listaPesquisa } = props

        let confComp = col.confComp
        let array = [];
        if (listaPesquisa) {

            listaPesquisa.forEach(element => {
                if (element[confComp.field]) {

                    element[confComp.field].forEach(item => array.push(item))
                }
            });
        }


        return <FiltroStringScorpion
            name={"filtro" + col.id} label={col.label}
            style={{ flex: 1, padding: 5 }}
            sugestoes={array}
            strComparaLike={item => {
                let str = "";
                let tta = item[confComp.field]
                if (!tta) {
                    return "";
                }
                tta.forEach(r => str = str + r)
                let r = col.getValue(item)
                return str;
            }}
        />
    }
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Tags/index.js